import { mapGetters } from 'vuex'
export default {
  name: 'Btn',
  components: {},
  props: ["classNames", "text", "styleObj"],
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters([
      "unsettledTransactionIds"
    ])
  },
  mounted () {

  },
  methods: {
    clickHandler (event) {
      switch (event) {
        case 'Pay now':
          this.navigateToCoupons()
          break;
      }
    },
    navigateToCoupons () {

    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Btn/component.js